import api from '../token';

export const DeleteConta = async (dados) => {
  try {
    const response = await api.post('/deleteConta', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};







